// @flow

import { Navigate, useParams } from 'react-router-dom';

import type { StaticHandlerArgs } from '@gandi/app-runner/server';

export type Params = {
  cartId?: string,
  productId?: string,
};
export default function SimpleHostingOneClickRedirect(): React$Element<
  typeof Navigate,
> {
  const { cartId, productId } = useParams();
  const to = ['/simplehosting/create', cartId, productId].join('/');

  return <Navigate to={to} />;
}

SimpleHostingOneClickRedirect.handleRedirect = ({
  params: { cartId, productId },
  redirect,
}: StaticHandlerArgs<{}, Params>): any => {
  const to = ['/simplehosting/create', cartId, productId].join('/');
  return redirect(to);
};
